/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : CartPopup.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H352615
*
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : connedted to reudux and get cart details servcies (ASDS-909)
 *
 * By            : H352615
 * On            : Aug 16, 2019
 * Description   : Integrated Cart view response structure with ASDS-909
 * By            : Avanthi G (E860178)
 * On            : Sep 06, 2019
 * Description   : Sending Dymanic UserID for fetching mycart details service and add to cart service(ASDS-1173)
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description  : ASDS-584
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Not displaying cart icon & popup, when the address is empty.
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS-3262, ASDS-3263 UI Enhancements Phase - II
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
******************************************************************************/

import React from 'react';
import { Badge, Card, Icon, Popup } from '@scuf/common';
import CartView from './CartView';
import { CheckoutUILabels } from '../constants/checkout-constants';
import './CartPopup.css';
import CartIconImage from './images/cart-icon.svg';
import { connect } from 'react-redux';
import CartDetailsActions from '../redux/actions/cart-details-actions';
import { logInfo } from '../../../utils/console-utility';
import DeleteProduct from '../ProductList/DeleteProduct';
import ProductDeleteToastNotification from '../Notifications/ProductDeleteToastNotification';

const ReactToastify =  require('react-toastify');

/**
* @author ASDS Team
* @description Layout for Cart Popup
*/
class CartPopup extends React.Component<any, any> {
    componentDidMount() {
        const userId = this.props.userValidationData.payload.userInfo.customer_sub;
        if (!userId) {
            logInfo("Invalid UserId")
        }
        else {
            this.props.getAbstractCartView(userId, "abstract");
        }
    }

    cartIcon() {
        return (
            <div className="cart-icon-wrapper" onClick={() => this.toggleCart()}>
                <img src={CartIconImage} className="cart-icon popup-pointer" alt="Cart Icon"/>
                <Badge color="green" className="cart-count">{this.props.cartCount}</Badge>
            </div>
        );
    }

    notify(value: boolean) {
        if(this.props.showDeleteMsgFlag) {
          ReactToastify.toast(<ProductDeleteToastNotification success={value} closeToast={false}/>);
          this.props.showDeleteMsg(false);
        }
    }

    handleDeleteProduct() {
        this.props.deleteProduct(this.props.product);
        this.props.toggleDeletePopUp(false);
    }

    toggleCart() {
        this.props.toggleCartIcon(!this.props.openCartIcon);
    }

    render() {
        this.notify(this.props.isProductDeleted);

        if ( ! this.props.userValidationData.payload.userAddrDetails ) {
            return '';
        } else {
            return (
                <React.Fragment>
                    {this.props.showDeletePopUp && <DeleteProduct
                        product={this.props.product}
                        onClose={() => {this.props.toggleDeletePopUp(false); }}
                        open={this.props.showDeletePopUp}
                        onClick={() => { this.handleDeleteProduct(); }}
                    />}

                    <Popup element={this.cartIcon()} className="cart-popup" position="bottom right" open={this.props.openCartIcon}>
                        <Card className="cartPopup">
                            <Card.Header className="cart-popup-header" title={CheckoutUILabels.ADDED_TO_CART_MSG}>
                                <Icon className="close" size="small" name="close" onClick={() => { this.toggleCart(); }} />
                            </Card.Header>
                            <Card.Content>
                                <CartView />
                            </Card.Content>
                        </Card>
                    </Popup>
                </React.Fragment>
            );
        }
    }
}

function mapStateToProps(state) {
    const { cartDetails = {}, isFetching = true, isSuccess = true } = state.cartDetails.abstractView;
    return {
        isFetching,
        isSuccess,
        cartCount: cartDetails.cartList ? cartDetails.cartList.length : 0,
        userValidationData: state.userValidationData,
        product: state.cartDetails.product,
        showDeletePopUp: state.cartDetails.showDeletePopUp,
        showDeleteMsgFlag: state.cartDetails.showDeleteMsgFlag,
        isProductDeleted: state.cartDetails.isProductDeleted,
        openCartIcon: state.cartDetails.openCartIcon
    };
}

const mapDispatchToProps = {
    getAbstractCartView: CartDetailsActions.getCartData,
    toggleDeletePopUp: CartDetailsActions.toggleDeletePopUp,
    deleteProduct: CartDetailsActions.deleteProduct,
    showDeleteMsg: CartDetailsActions.showDeleteMsg,
    toggleCartIcon: CartDetailsActions.toggleCartIcon
};

export default connect(mapStateToProps, mapDispatchToProps)(CartPopup);
